'use client';

import { useEffect } from 'react';
import Lenis from 'lenis';

interface LenisProviderProps {
  children: React.ReactNode;
}

export default function LenisProvider({ children }: LenisProviderProps) {
  useEffect(() => {
    let rafId: number | null = null;
    let isMounted = true;

    // Initialize Lenis
    const lenis = new Lenis({
      duration: 0.3, // Reduced from 1.2 - shorter animation duration
      easing: (t) => 1 - Math.pow(1 - t, 3), // Less bouncy easing (cubic-out)
      wheelMultiplier: 0.6, // Mouse wheel sensitivity
      touchMultiplier: 1.3, // Touch scroll sensitivity
      infinite: false,
    });

    // Make lenis available globally for utility functions
    (window as unknown as { lenis: Lenis }).lenis = lenis;

    // Get scroll value
    lenis.on('scroll', () => {
      // You can add custom scroll handling here if needed
      // console.log(e)
    });

    // Use requestAnimationFrame to continuously update the scroll
    function raf(time: number) {
      if (!isMounted) return;
      
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }

    rafId = requestAnimationFrame(raf);

    // Cleanup
    return () => {
      isMounted = false;
      
      // Cancel any pending RAF first
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
      
      // Destroy Lenis instance
      try {
        lenis.destroy();
      } catch (error) {
        console.warn('Lenis cleanup error:', error);
      }
    };
  }, []);

  return <>{children}</>;
}
